import cx from 'classnames'
import { Icon } from '@vzmi/shp_shared_compo'
import styles from './NextArrow.css'

const NextArrow = ({ className }) => (
  <Icon
    name='caret-right'
    color='#5478fc'
    size={18}
    align='sub'
    className={cx(styles.activeArrow, className)}
  />
)

export default NextArrow
